import { render, staticRenderFns } from "./template-message.vue?vue&type=template&id=20d774d4&scoped=true&"
import script from "./template-message.vue?vue&type=script&lang=js&"
export * from "./template-message.vue?vue&type=script&lang=js&"
import style0 from "./template-message.vue?vue&type=style&index=0&id=20d774d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d774d4",
  null
  
)

export default component.exports